module.exports = __webpack_public_path__ + "static/media/Developmenticon04@2x.6cd52dc1.png";